"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasWindow = exports.isNodeEnv = exports.getGlobalObject = void 0;
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (isNodeEnv()
        ? global
        : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
exports.getGlobalObject = getGlobalObject;
/**
 * Checks whether we're in the Node.js or Browser enviroment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    return (Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) ===
        '[object process]');
}
exports.isNodeEnv = isNodeEnv;
function hasWindow() {
    return typeof window !== 'undefined';
}
exports.hasWindow = hasWindow;
